module.exports = __webpack_public_path__ + "static/media/drag drop icon.4027d747.svg";